export function NormasTeachingLogo() {
  return (
    <img
      src="https://storage.googleapis.com/norma-dev-general/Norma-logo-with-name.png"
      alt="normaLogo"
      className="md:max-w-[200px] max-w-[200px]"
    />
  );
}
